<div
  class="category-details-view-container"
  *ngIf="blogCategoryObject"
  fxLayout="column"
  fxLayoutGap="15px"
>
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).dobry_agent.write"
      (click)="modify()"
      mat-stroked-button
      color="primary"
    >
      <mat-icon>create</mat-icon>
      <span> Edytuj</span>
    </button>
    <button
      (click)="deleteWeak(blogCategoryObject.uuid)"  mat-stroked-button >
      <mat-icon>archive</mat-icon>
      <span> Przenieś do archiwum</span>
    </button>
    <button
      (click)="delete(blogCategoryObject)"  mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Usuń</span>
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column" >

        <app-section-header
          title="Dane kategorii"
          description="Podstawowe informacje i ustawienia kategorii."
        ></app-section-header>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="Nazwa kategorii"
              [value]="blogCategoryObject.name"
            ></app-detail>
          </div>
          <div fxFlex="50">
            <app-detail
              header="Pozycja"
              [value]="blogCategoryObject.position?.toString()"
            ></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="Opis"

            ><span   [innerHTML]="blogCategoryObject.description"></span></app-detail>
          </div>
        </div>

        <div fxLayout="column" fxLayoutGap="15px">
          <div *ngIf="blogCategoryObject.icon" class="selected-file-name" fxFlex="100">
            <img src="{{ blogCategoryObject.icon }}" alt="Aktualna ikona" class="selected-icon-image">
          </div>
          <ng-container *ngIf="!blogCategoryObject.icon" >
            <img class="icon-image"
                 [src]="'/assets/avatar.png'"
                 alt="Zdjęcie"/>
            <span style="margin-top:15px">Brak ikony</span>
          </ng-container>
          <div fxFlex="100">
            <app-detail
              header="Alt obrazka"
              [value]="blogCategoryObject.altImage"
            ></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">

            <app-detail
              fxFlex="100"
              header="Status"
            >
            <app-detail-bool
              [header]="blogCategoryObject.active ? 'Aktywny': 'Nieaktywny'"
              [value]="blogCategoryObject.active"
            ></app-detail-bool>
          </app-detail>
        </div>
      </mat-card>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column">
        <app-section-header
          title="SEO"
          description="Ustawienia widoczności kategorii w wynikach wyszukiwania."
        ></app-section-header>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="SEO slug"
              [value]="blogCategoryObject.seoSlug"
            ></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="SEO title"
              [value]="blogCategoryObject.seoTitle"
            ></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="SEO description"
              [value]="blogCategoryObject.seoDescription"
            ></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="SEO keywords"
              [value]="blogCategoryObject.seoKeywords"
            ></app-detail>
          </div>
        </div>

      </mat-card>
    </div>
  </div>
</div>
